// ===== PARTY RENTAL SOLUTIONS - MAIN JAVASCRIPT =====

// Import modules
import { initMobileMenu, initSmoothScrolling, initScrollSpy } from './modules/navigation.js';
import { initFAQ } from './modules/faq.js';
import { initROICalculator } from './modules/roi-calculator.js';
import { initROIForm } from './modules/forms.js';
import { initLazyLoading } from './modules/lazy-load.js';
import { initAnalytics, logWelcomeMessage } from './modules/analytics.js';
import { initChatbotCarousel } from './modules/chatbot-carousel.js';
import { initHeroCarousel } from './modules/hero-carousel.js';
import { initReturnToTop } from './modules/return-to-top.js';
import { initTemplateSlider } from './modules/template-slider.js';
import { initCoreFeatureCarousel } from './modules/core-features-carousel.js';
import { initImageModal } from './modules/image-modal.js';

// Initialize all modules when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    // Navigation
    initMobileMenu();
    initSmoothScrolling();
    initScrollSpy();

    // FAQ Accordion
    initFAQ();

    // ROI Calculator
    initROICalculator();
    initROIForm();

    // Lazy Loading
    initLazyLoading();

    // Analytics
    initAnalytics();

    // Welcome message
    logWelcomeMessage();

    // Chatbot Carousel
    initChatbotCarousel();

    // Hero Visual Carousel
    initHeroCarousel();

    // Return to Top Button
    initReturnToTop();

    // Template Screenshots Slider
    initTemplateSlider();

    // Core Features Carousel
    initCoreFeatureCarousel();

    // Image Modal / Lightbox
    initImageModal();
});
